// src/components/AddPlatformModal.jsx
import React, { useState } from "react";

export default function AddPlatformModal({ open, onClose, onCreated }) {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("Académico");
  const [url, setUrl] = useState("");
  const [admins, setAdmins] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSaving(true);

    try {
      const payload = {
        name: name.trim(),
        category,
        url: url.trim(),
        admins: admins.split(",").map(s => s.trim()).filter(Boolean)
      };

      console.log("Submitting platform payload:", payload);

      const res = await fetch("/api/platforms.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || `HTTP ${res.status}`);
      }

      const created = await res.json();
      console.log("AddPlatform response:", created);

      // Normaliza a resposta do backend
      const platformObj =
        created && typeof created === "object"
          ? created.id || created.name
            ? created
            : created.received || created
          : created;

      const safePlatform = {
        id: platformObj?.id || `plat_${Date.now()}`,
        name: platformObj?.name || platformObj?.title || "(sem nome)",
        category: platformObj?.category || "Outro",
        url: platformObj?.url || "",
        admins: Array.isArray(platformObj?.admins)
          ? platformObj.admins
          : platformObj?.admins
          ? [platformObj.admins]
          : []
      };

      try {
        onCreated(safePlatform);
      } catch (err) {
        console.error("Erro no onCreated handler:", err);
        setError("Erro interno ao processar a plataforma");
        return;
      }

      // Limpeza
      setName("");
      setCategory("Académico");
      setUrl("");
      setAdmins("");
      onClose();
    } catch (err) {
      console.error(err);
      setError(err.message || "Erro ao guardar");
    } finally {
      setSaving(false);
    }
  }

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded w-full max-w-lg">
        <h3 className="text-lg font-semibold mb-4">Adicionar Plataforma</h3>

        <label className="block text-sm">Nome</label>
        <input
          required
          value={name}
          onChange={e => setName(e.target.value)}
          className="w-full p-2 border rounded mb-2"
        />

        <label className="block text-sm">Categoria</label>
        <select
          value={category}
          onChange={e => setCategory(e.target.value)}
          className="w-full p-2 border rounded mb-2"
        >
          <option>Académico</option>
          <option>Suporte</option>
          <option>Infraestrutura</option>
          <option>Comunicação</option>
          <option>Outro</option>
        </select>

        <label className="block text-sm">URL</label>
        <input
          required
          type="url"
          value={url}
          onChange={e => setUrl(e.target.value)}
          className="w-full p-2 border rounded mb-2"
        />

        <label className="block text-sm">Admins (separados por vírgula)</label>
        <input
          value={admins}
          onChange={e => setAdmins(e.target.value)}
          placeholder="ops@uatlantica.pt, infra@..."
          className="w-full p-2 border rounded mb-4"
        />

        {error && <div className="text-red-600 mb-2">{error}</div>}

        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-3 py-2 border rounded">
            Cancelar
          </button>
          <button type="submit" disabled={saving} className="px-3 py-2 bg-indigo-600 text-white rounded">
            {saving ? "A guardar..." : "Adicionar"}
          </button>
        </div>
      </form>
    </div>
  );
}
